import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/news/searchkeyword/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/news/searchkeyword',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/news/searchkeyword/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/news/searchkeyword/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/news/searchkeyword',
    method: 'put',
    data: obj
  })
}
